export function getGiftCodeUrl(giftCode: string) {
  return `https://giftcard.realworld.to/?directCode=${giftCode}`;
}
